export const DOMAIN_AUTH = "AUTH";
